const GAP = 6;
const ABOVE_GAP = 8;
const MARGIN = 8;

export function placeCapacityPopover({ place, anchor, column, bounds, viewport, width, height }) {
  let left = anchor.left;
  if (column) left = column.left;
  else if (place === "below") left = anchor.right - width;
  left = Math.max(bounds.left, Math.min(left, bounds.right - width));

  const gap = place === "above" ? ABOVE_GAP : GAP;
  const below = anchor.bottom + gap;
  const above = anchor.top - gap - height;
  const roomBelow = viewport.bottom - MARGIN - below;
  const roomAbove = anchor.top - gap - (viewport.top + MARGIN);
  const fitsBelow = height <= roomBelow;
  const fitsAbove = height <= roomAbove;
  const prefersAbove = place === "above";

  if (!fitsBelow && !fitsAbove) {
    const side = roomAbove > roomBelow || (roomAbove === roomBelow && prefersAbove) ? "above" : "below";
    const maxHeight = Math.max(0, side === "above" ? roomAbove : roomBelow);
    return { left, top: side === "above" ? anchor.top - gap - maxHeight : below, side, maxHeight };
  }

  const side = prefersAbove ? (fitsAbove ? "above" : "below") : fitsBelow ? "below" : "above";
  return { left, top: side === "above" ? above : below, side };
}
